import type { CitationSource, AIPlatform } from '../types';
import {
  GBIBadge, GBICard, Icon, T, sharedStyles,
} from './Shared';

interface CitationsScreenProps {
  sources: CitationSource[];
}

const PLATFORM_COLOR: Record<AIPlatform, string> = {
  chatgpt: T.chatgpt,
  perplexity: T.perplexity,
  gemini: T.gemini,
};

export function CitationsScreen({ sources }: CitationsScreenProps) {
  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: 28, background: T.bgVoid }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: sharedStyles.fontDisplay, fontSize: 22, fontWeight: 700, color: T.fgPrimary, marginBottom: 4 }}>Citation Sources</div>
        <div style={{ fontSize: 13, color: T.fgSecondary }}>Which domains AI platforms trust when recommending your category</div>
      </div>
      <GBICard>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 120px 180px 120px', gap: 0 }}>
          {['Domain', 'AI Trust Score', 'Platforms', 'Category'].map(h => (
            <div key={h} style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: T.fgMuted, padding: '0 0 12px', borderBottom: `1px solid ${T.border}` }}>{h}</div>
          ))}
          {sources.map(s => (
            <div key={s.domain} style={{ display: 'contents' }}>
              <div style={{ padding: '14px 0', borderBottom: `1px solid ${T.border}`, display: 'flex', alignItems: 'center', gap: 8 }}>
                <Icon name="globe" size={14} color={s.trust > 80 ? T.cyan : T.fgMuted} />
                <span style={{ fontFamily: sharedStyles.fontMono, fontSize: 13, color: s.trust > 0 ? T.fgPrimary : T.fgMuted }}>{s.domain}</span>
                {s.trust > 85 && <GBIBadge color={T.cyan} style={{ fontSize: 9 }}>High Trust</GBIBadge>}
              </div>
              <div style={{ padding: '14px 0', borderBottom: `1px solid ${T.border}`, display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ height: 4, width: `${s.trust * 0.7}px`, background: s.trust > 80 ? T.cyan : s.trust > 50 ? T.amber : T.fgMuted, borderRadius: 2 }} />
                <span style={{ fontFamily: sharedStyles.fontMono, fontSize: 12, color: s.trust > 80 ? T.cyan : T.fgSecondary }}>{s.trust}%</span>
              </div>
              <div style={{ padding: '14px 0', borderBottom: `1px solid ${T.border}`, display: 'flex', alignItems: 'center', gap: 6 }}>
                {(['chatgpt','perplexity','gemini'] as AIPlatform[]).map(p => (
                  <div key={p} style={{
                    width: 8, height: 8, borderRadius: '50%',
                    background: s.platforms.includes(p) ? PLATFORM_COLOR[p] : T.bgOverlay,
                    opacity: s.platforms.includes(p) ? 1 : 0.3,
                  }} title={p} />
                ))}
              </div>
              <div style={{ padding: '14px 0', borderBottom: `1px solid ${T.border}`, fontSize: 12, color: T.fgSecondary }}>{s.category}</div>
            </div>
          ))}
        </div>
      </GBICard>
    </div>
  );
}
